import { ImageComponent } from "../../components/ImageComponent/ImageComponent";

export const LoginImageContainer = () => {
  const src =
    "https://d302y7dk73tjzt.cloudfront.net/media/landing/background/photo/cover.webp";

  return <ImageComponent src={src} alt={"logon admin"} />;
};
